<template>
  <div class="nav-header">
    <div class="nav-menu-top" :style="{ width: `${menuWidth}px` }">
      <div class="logo-container" ref="logoContainer" v-if="showMenu">
        <img
          class="logo"
          src="../../../assets/home/logo_H.png"
          alt="hanshow"
          style="margin-left:-1px;"
        />
      </div>
      <div class="app-change-right">
        <el-dropdown @command="changeApp" trigger="hover" placement="right-start" :style="{'justify-content': showMenu?'flex-end':'flex-start'}">
          <div>
            <div class="app-change" v-show="showMenu">
              <div class="app-name" :style="{width:`calc(${menuWidth}px - 105px)`}">
                <span v-if='$t(`apps.${currentAppName.toLowerCase()}`)==`apps.${currentAppName.toLowerCase()}`'>{{currentAppName}}</span>
                <span v-else>{{ $t(`apps.${currentAppName.toLowerCase()}`)}}</span>
              </div>
              <i class="el-icon-arrow-right" style="color:#fff"></i>
            </div>
            <div class="app-icon" v-show="!showMenu">
              <img :src="currentAppIcon"/>
            </div>
          </div>
          <el-dropdown-menu
            class="app-select-container"
            slot="dropdown"
          >
            <el-dropdown-item
              v-for="(app, index) in choseApps"
              :key="index"
              :class="{ selected: currentAppName == app.appName }"
              :command="app.appName"
              :divided="app.appType?app.appType.toLowerCase()=='template'&&choseApps.length>1:false"
              >
              <div style="display:flex;align-items: center;">
                <div class="icon-container">
                  <img :src="app.appIcon" style="width:24px"/>
                </div>
                <span>
                  <span v-if='$t(`apps.${app.appName.toLowerCase()}`)==`apps.${app.appName.toLowerCase()}`'>{{app.appName}}</span>
                  <span v-else>{{ $t(`apps.${app.appName.toLowerCase()}`)}}</span>
                </span>
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>

    <div class="nav-right">
      <div class="customer-select" v-if="pageStatu">
        <i class="HSIconfont hs-icon-ic_client2"></i>
        <el-select
          id="customerSelect"
          v-model="currentCustomer"
          :popper-append-to-body="false"
          filterable
          placeholder=" "
          @change='handleCustomerChange'
        >
          <el-option
            v-for="item in customers"
            :key="item.orgCode"
            :label="`${item.orgName}(${item.orgCode})`"
            :value="item.orgCode"
            :id="item.orgCode"
          >
          </el-option>
        </el-select>
      </div>

      <div class="store-select" v-if="hiddenStoreChose && pageStatu">
        <i class="HSIconfont hs-icon-store"></i>
        <el-select
          id="storeSelect"
          v-model="currentStore"
          :popper-append-to-body="false"
          filterable
          placeholder=" "
          :clearable="canClearStores"
        >
          <el-option
            v-for="item in currentCustomerStores"
            :key="item.id"
            :label="`${item.terminalName}(${item.terminal})`"
            :value="item.terminal"
            :id="`${item.org}.${item.terminal}`"
          >
          </el-option>
        </el-select>
      </div>

      <div class="top-divider" v-if="pageStatu">
        <el-divider direction="vertical"></el-divider>
      </div>

      <language></language>

      <message-center></message-center>

      <div class="user-operate-container">
        <el-dropdown
          @command="userOperateHandler"
          placement="bottom"
          class="user-dropdown"
        >
          <div class="user-info">
            <i class="HSIconfont hs-icon-a-Individualcenter"></i>
            <span class="userName">{{
              isEmpty(this.currentUser.nickname)
                ? this.currentUser.username
                : this.currentUser.nickname
            }}</span>
            <i style="margin-left: 8px" class="dropdown el-icon-caret-bottom" />
          </div>
          <el-dropdown-menu slot="dropdown" class="nav-user-dropdown">
            <div class="user-name">
              {{
                isEmpty(this.currentUser.nickname)
                  ? this.currentUser.username
                  : this.currentUser.nickname
              }}
            </div>
            <template v-for="(item, index) in userOperate">
              <div
                :key="`d-${index}`"
                class="self-divider"
                v-if="item.divider"
              ></div>
              <el-dropdown-item
                :key="index"
                v-if="item.show()"
                v-bind="item.props"
                ><i :class="item.icon" />{{
                  typeof item.label == "string"
                    ? $t(item.label)
                    : $t(item.label())
                }}
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "@/utils/utils";
// import { contactSocket, webSocket, clearTimer } from "@/utils/wsUtils.js";
import { initState as globalState } from "@/store/shardActions";
import Language from "@/components/Language";
import MessageCenter from "./MessageCenter.vue";
export default {
  components: {
    Language,
    MessageCenter,
  },

  computed: {
    appIconPath() {
      return (app) => require(`@/assets/home/${app.appName}`);
    },
    menuWidth() {
      return globalState.menuWidth;
    },
    showMenu() {
      return globalState.showMenu;
    }, 

    pageStatu() {
      // 页面状态  为true 表示当前在业务页面
      return globalState.servicePage;
    },

    currentUser() {
      return globalState.currentUser;
    },

    hasAsPermission() {
      return this.$store.state.config.hasAsPermission;
    },

    hasBothPermission() {
      const permissionTree = globalState.permissionTree["All-Star"] || [];
      let systemPermission = permissionTree.some(
        (item) => item.realm == "SYSTEM" || item.realm == "GLOBAL"
      );
      let normalPermission = permissionTree.some(
        (item) => item.realm == "OPERATOR" || item.realm == "ADMIN"
      );
      return systemPermission && normalPermission;
    },

    choseApps() {
      let choseApps = [];
      let managePageApps = window.HS_CONFIG.managePageApps;
      let manageShowApps = this.$store.state.config.manageApps;
      const apps= [...new Set(manageShowApps.concat(managePageApps))]
      if (this.pageStatu) {//业务页面
        let template=null;
        this.$store.state.config.apps.forEach((app) => {
          let src=app.icon;
          if(this.internalAppIcons.indexOf(app.appName.toLowerCase())!=-1){
            src=require(`@/assets/home/${app.appName.toLowerCase()}.png`);
          }
          
          if(app.appType?.toLowerCase()=='template'){
            template={
              appName: app.appName,
              activeRule: app.activeRule,
              entry: app.entry,
              newWindow: app.newWindow || false,
              appType: app.appType,
              appIcon: src
            }
          }else{
            choseApps.push({
              appName: app.appName,
              activeRule: app.activeRule,
              entry: app.entry,
              newWindow: app.newWindow || false,
              appType: app.appType,
              appIcon: src
            });
          }
        });
        this.$store.state.config.plugins.forEach((plugin) => {
          let src=plugin.icon;
          if(this.internalAppIcons.indexOf(plugin.appName.toLowerCase())!=-1){
            src=require(`@/assets/home/${plugin.appName.toLowerCase()}.png`)
          }
          choseApps.push({
            appName: plugin.appName,
            activeRule: plugin.activeRule,
            entry: plugin.entry,
            newWindow: plugin.newWindow || false,
            appType: plugin.appType,
            appIcon: src
          });
        });
        if(!isEmpty(template)){//template放在最后
          choseApps.push(template);
        }
      } else {
        let template=null;
        this.$store.state.config.apps
          .filter((item) => apps.includes(item.appName))
          .forEach((app) => {
            let src=app.icon;
            if(this.internalAppIcons.indexOf(app.appName.toLowerCase())!=-1){
              src=require(`@/assets/home/${app.appName.toLowerCase()}.png`)
            }
            if(app.appType?.toLowerCase()=='template'){
              template={
                appName: app.appName,
                activeRule: app.activeRule,
                entry: app.entry,
                newWindow: app.newWindow || false,
                appType: app.appType,
                appIcon:src
              }
            }else{
              choseApps.push({
                appName: app.appName,
                activeRule: app.activeRule,
                entry: app.entry,
                newWindow: app.newWindow || false,
                appIcon:src
              });
            }
          });
        if(!isEmpty(template)){//template放在最后
          choseApps.push(template);
        }
      }
      return choseApps;
    },

    currentAppName() {
      return globalState.currentAppName || "";
    },
    currentAppIcon(){
      return globalState.currentAppIcon||""
    },
    canClearStores() {
      let userDomain = this.$store.state.config.userInfo?.domains;

      if (userDomain == undefined) {
        return false;
      } else if (userDomain == "**") {
        return true;
      } else {
        userDomain = userDomain.split(",");
        let domains = userDomain.filter((item) => item.indexOf("**") != -1);
        if (domains.length) {
          let orgCodes = userDomain.map((item) => item.replace(".**", ""));
          if (orgCodes.includes(this.currentCustomer)) {
            return true;
          }
        } else {
          return false;
        }
      }
      return false;
    },

    hiddenStoreChose() {
      let apps = window.HS_CONFIG.storeHiddenApp || [];
      return !apps.some(
        (item) => item.toLowerCase() == this.currentAppName.toLowerCase()
      );
    },

    // currentCustomer: {
    //   get() {
    //     return globalState.currentCustomer;
    //   },
    //   set(val){
    //     console.info('this',this.currentCustomerStores)
    //     if (!this.canClearStores) {
    //       this.currentStore = this.currentCustomerStores[0]
    //         ? this.currentCustomerStores[0].terminal
    //         : "";
    //     } else {
    //       this.currentStore = "";
    //     }
    //     this.$actions.setGlobalState({
    //       currentCustomer: val,
    //     });
    //   },
    // },

    currentStore: {
      get() {
        return globalState.currentStore;
      },
      set(val) {
        this.$actions.setGlobalState({
          currentStore: val,
        });
      },
    },

    customers() {
      return globalState.commonData.customer || [];
    },
    customerStores(){
      return globalState.commonData.data
    },
    currentLanguage() {
      return globalState.currentLanguage
    }
  },
  watch: {
    customerStores(newVal) {
      if(newVal&&this.currentCustomer){
        this.currentCustomerStores=newVal.find(
            (item) => item.customer.orgCode == this.currentCustomer
          )?.terminals ?? []
      }else{
        this.currentCustomerStores=[]
      }
    },
  },
  data() {
    return {
      userOperate: [
        {
          show: () => this.hasAsPermission,
          props: {
            id: "userInfo",
            command: "userInfo",
          },
          icon: "HSIconfont hs-icon-a-Personalinformation",
          label: "button.userInfo",
        },
        {
          show: () =>
            this.hasAsPermission && this.currentUser.source == "All-Star",
          props: {
            id: "pwdChange",
            command: "pwdChange",
          },
          icon: "HSIconfont hs-icon-password",
          label: "button.passwordChange",
        },
        {
          show: () => this.hasAsPermission,
          props: {
            id: "messageCenter",
            command: "messageCenter",
          },
          icon: "HSIconfont hs-icon-notification",
          label: "button.messageCenter",
        },
        {
          show: () => this.hasAsPermission && this.hasBothPermission,
          props: {
            id: "pageChange",
            command: "pageChange",
          },
          icon: "HSIconfont hs-icon-a-Settings1",
          label: () =>
            this.pageStatu ? "button.toManagePage" : "button.toServicePage",
        },
        {
          show: () => this.hasAsPermission,
          props: {
            id: "versionInfo",
            command: "versionInfo",
          },
          icon: "HSIconfont hs-icon-Version",
          label: "appsVersion.systemVersion",
        },
        {
          show: () => true,
          divider: true,
          props: {
            id: "logout",
            command: "exit",
          },
          icon: "HSIconfont hs-icon-quit",
          label: "button.logout",
        },
      ],
      currentCustomer:'',
      currentCustomerStores:[],
      navHover:false,
      showFull:true,
      logoWidthEnough:true,
      showLogo:true,
      appIcon:'',
      internalAppIcons:['all-star','assetmanager','fe','mars','mapserver','aurora','prismart','template','plugin@saas-subscribe','feature']
    };
  },
  created () {
    this.currentCustomer=globalState.currentCustomer;
    this.currentCustomerStores=this.getCustomerStores();
  },
  methods: {
    isEmpty,
    userOperateHandler(val) {
      switch (val) {
        case "exit":
          this.$store.dispatch("config/logout");
          break;

        case "userInfo":
        case "pwdChange":
        case "versionInfo":
        case "messageCenter":
          this.$actions.setGlobalState({ asFirstInPage: val });
          break;

        case "pageChange":
          this.$actions.setGlobalState({
            servicePage: !globalState.servicePage,
          });
          break;

        default:
          break;
      }
      if (val !== "exit") {
        let isAllStar = this.currentAppName.toLowerCase() == "all-star";
        let url = val;
        const app = this.choseApps.find(
          (item) => item.appName.toLowerCase() == "all-star"
        );
        let activeRule = "";
        if (typeof app.activeRule == "string") {
          activeRule = app.activeRule;
        } else {
          activeRule = app.activeRule[0];
        }
        activeRule = activeRule.slice(
          activeRule.indexOf("#") + 1,
          activeRule.length
        );
        if (!isAllStar) {
          this.$actions.setGlobalState({
            currentAppName: app.appName,
            currentAppIcon:app.appIcon
          });
          url=val=='pageChange' ? `${activeRule}` : `${activeRule}/${val}`;
          this.$router.push(url);
        }
        // else{
        //   if(val == "pageChange"){
        //     url=activeRule
        //     this.$router.push(url);
        //   }
        // }
      }
    },

    changeApp(appName) {
      //TODO 切换子应用或插件逻辑
      const app = this.choseApps.find((item) => item.appName == appName);
      if (app.newWindow) {
        let url = app.entry;
        let accessToken = globalState.accessToken;
        url += "?token=" + accessToken;
        window.open(url);
        return;
      }
      let activeRule = "";
      if (typeof app.activeRule == "string") {
        activeRule = app.activeRule;
      } else {
        activeRule = app.activeRule[0];
      }
      activeRule = activeRule.slice(
        activeRule.indexOf("#") + 1,
        activeRule.length
      );
      this.$router.push(activeRule);
      this.$actions.setGlobalState({
        currentAppName: app.appName,
        currentAppIcon: app.appIcon
      });
    },
    handleCustomerChange(customer){
      this.currentCustomerStores=this.getCustomerStores();
      if (!this.canClearStores) {
        this.currentStore = this.currentCustomerStores[0]
          ? this.currentCustomerStores[0].terminal
          : "";
      } else {
        this.currentStore = "";
      }
      this.$actions.setGlobalState({
        currentCustomer: customer,
      });
    },
    getCustomerStores() {
      if (this.currentCustomer && !isEmpty(globalState.commonData.data)) {
        return globalState.commonData.data.find(
            (item) => item.customer.orgCode == this.currentCustomer
          )?.terminals ?? []
      } else {
        return [];
      }
    }
  }
};
</script>
<style lang="scss">
.nav-user-dropdown {
  min-width: 160px;
  max-width: 260px;
  top: 50px !important;
  .user-name {
    margin: 2px 14px 12px 14px;
    max-height: 32px;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: $font-color-regular;
  }
  li {
    padding: 0 14px;
    min-height: 32px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    i {
      font-size: 18px;
      margin-right: 8px;
    }
  }
  li:nth-of-type(1) {
    border-top: 1px solid $border-color;
  }
  .self-divider {
    border-top: 1px solid $border-color;
    margin: 4px 14px;
  }
}
</style>
<style lang="scss" scoped>
.nav-header {
  height: 51px;
  background-color: $grayBg;
  display: flex;
  flex-shrink: 0;

  .el-dropdown-menu {
    top: 27px !important;
    left: 0 !important;
    border-radius: 8px;
    background-color: #fff;
    padding-top: 0;
    padding-bottom: 0;
  }

  .el-dropdown-menu__item {
    padding: 0 16px;
    white-space: nowrap;
    &.selected {
      color: $primary;
      background-color: #e4edf9;
    }
  }
  .nav-menu-top {
    background-color: $primary;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    padding:0 8px;
    position: relative;
    justify-content: space-between;
    // &::before {
    //   content: "";
    //   position: absolute;
    //   bottom: 0;
    //   right: 0;
    //   width: 23px;
    //   height: 100%;
    //   background: linear-gradient(273deg, #015ac5 27%, rgba(1, 90, 197, 0) 93%);
    // }

    .el-dropdown {
      display: flex;
      align-items: center;
    }
    .app-change-right{
      flex:1;
      margin-left:8px;
      border-radius: 8px;
      &:hover{
        cursor: pointer;
        background:#1567CA;
      }
    }
    .app-change{
      display: flex;
      align-items: center;
      overflow: hidden;
      padding:0 8px;
      height:40px;
      width:100%;
      justify-content: flex-end;
     
      .app-name{
        color:#fff;
        font-size:14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right:8px;
        text-align: right;
      }
    }
    .app-icon{
      border-radius:8px;
      width:40px;
      height:40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background:#fff;
      margin-left:-4px;
      img{
        width:24px;
      }
      &:hover{
        cursor: pointer;
      }
    }
    .logo-container{
      border-radius: 8px;
      background:#F8F8F8;
      display: flex;
      align-items: center;
      justify-content: center;
      width:40px;
      height:40px;
      flex-shrink: 0;
    }
    .logo {
      width: 25px;
    }
    
  }

  .nav-right {
    // min-width: 1000px;
    flex: auto;
    padding-right: 16px;
    display: flex;
    justify-content: flex-end;
    border-bottom: 1px solid $border-color;

    .customer-select,
    .store-select {
      display: flex;
      align-items: center;
      margin-right: 16px;

      i {
        font-size: 16px;
        margin-right: 8px;
      }

      .el-select {
        width: 210px;
      }
    }

    .top-divider {
      padding-right: 8px;
      display: flex;
      align-items: center;
      .el-divider {
        height: 20px;
      }
    }

    .user-operate-container {
      display: flex;
      padding-left: 25px;
      flex-wrap: nowrap;
      align-items: center;
      .user-dropdown{
        cursor: pointer;
      }
      .user-info {
        // min-width: 107px;
        max-width: 210px;
        display: flex;
        align-items: center;
        .HSIconfont {
          flex-shrink: 0;
          color: $primary;
          font-size: 18px;
        }
        .userName {
          text-indent: 6px;
          flex: auto;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .dropdown {
          flex-shrink: 0;
          padding-right: 8px;
          // align-items: flex-end;
        }
        // height: 30px;
      }
    }
  }
}
::v-deep.app-select-container {
  min-width: 200px;
  padding:12px 20px 12px 4px!important;
  .app-change-title {
    text-indent: 16px;
    height: 32px;
    line-height: 32px;
    margin: 0;
    font-weight: $font-bold;
  }

  .el-dropdown-menu__item--divided {
    margin-top: 0;
    &::before {
      display: none;
    }
  }
  .el-dropdown-menu__item--divided{
    border-top:1px solid #D8D8D8;
    margin-top:8px;
    padding-top:8px;
  }
  .el-dropdown-menu__item{
    height:52px;
    line-height:52px;
    font-size:14px;
    font-weight: 500;
    &:hover,&.selected{
      background: #E4EDF9;
      border-radius: 8px;
      color:#015AC5;
    }
    .icon-container {
      // border-radius: 8px;
      // background:#1B6BCB;
      display: flex;
      align-items: center;
      // justify-content: center;
      // width:40px;
      // height:40px;
      margin-right:18px;
    }
  }
}
</style>
